import useScript from '../useScript';

export default function useRecurlyJs (): boolean {
  return useScript('https://js.recurly.com/v4/recurly.js');
}
